<template>
  <div>
    <h1 class="view-title mb-12 text-center">{{ params.title }}</h1>

    <div
      v-if="params.img"
      class="d-flex flex-column align-center mb-6 text-center"
      id="image"
    >
      <img :src="params.img.src" class="oval-frame mb-6" />
      <small v-if="params.img.title" v-html="params.img.title"></small>
    </div>

    <!-- <v-row justify="center">
      <v-col cols="2">
        <v-card flat>
          <v-text-field
            outlined
            placeholder="Keresés"
            prepend-inner-icon="mdi-magnify"
            hide-details
            clearable
            x-large
            class="keyboard-input"
            v-model="$store.state.keyboard.value"
            @input="input"
            @focus="focus"
          ></v-text-field>
        </v-card>
      </v-col>
    </v-row> -->

    <template v-if="!this.$store.state.keyboard.value">
      <v-row
        v-for="(groupOf100, i) in params.items"
        :key="`group-of-100-${i}`"
        justify="center"
      >
        <v-col
          v-for="(groupOf10, j) in groupOf100"
          :key="`group-of-10-${j}`"
          cols="1"
        >
          <template v-for="(item, k) in groupOf10">
            <v-btn
              class="my-3"
              elevation="1"
              block
              color="white"
              :key="`item-${k}`"
              :disabled="!item.to"
              :to="item.to"
              >{{ item.title }}</v-btn
            >
          </template>
        </v-col>
      </v-row>
    </template>

    <v-row v-else justify="center">
      <v-col
        v-if="!filteredItems.length"
        class="text-center"
        justify="center"
        cols="8"
      >
        <h3>Nincs találat</h3>
      </v-col>
      <v-col
        v-for="(item, i) in filteredItems"
        :key="`filtered-item-${i}`"
        cols="8"
      >
        <v-card
          elevation="1"
          block
          color="white"
          :key="`item-${i}`"
          :disabled="!item.to"
          :to="item.to"
        >
          <v-card-title>
            {{ item.title }}
          </v-card-title>
          <!-- <v-card-text>
              {{ item. }}
            </v-card-text> -->
          <v-card-text>
            {{ item.description }}
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <portal to="main"></portal>
  </div>
</template>

<script>
import slugify from "slugify";

export default {
  props: ["params"],
  data: () => ({
    data: {},
    filteredItems: [],
    searchTimeout: null,
  }),
  mounted() {
    this.loadData();
  },
  methods: {
    onClickOutsideStandard() {
      this.$store.state.keyboard.visible = false;
    },
    include() {
      return [document.querySelector("#keyboard")];
    },
    loadData() {
      this.data = require(`@/../public/static/data/${this.$store.state.screenNumber}/index.json`); // eslint-disable-line
    },
    focus() {
      this.$nextTick(() => {
        this.$store.state.keyboard.visible = true;
      });
    },
    blur() {
      this.$store.state.keyboard.visible = false;
    },
    input() {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.filteredItems = this.filterItems();
      }, 1000);
    },
    searchInItems(keyword, items) {
      const searchableKeyword = slugify(keyword.toLowerCase());
      for (const [i, value] of items.entries()) {
        if (i === 0) {
          continue;
        }
        const stringifiedValue = value.join("  ");
        const searchableValue = slugify(stringifiedValue.toLowerCase());

        if (searchableValue.includes(searchableKeyword)) {
          return stringifiedValue;
        }
      }
      return false;
    },
    filterItems() {
      const filteredItems = [];
      if (this.$store.state.keyboard.value === "") {
        return filteredItems;
      }

      for (const [key, value] of Object.entries(this.data)) {
        if (!key.startsWith("/") || key === "/") {
          continue;
        }

        const result = this.searchInItems(
          this.$store.state.keyboard.value,
          value.params.items
        );
        if (result) {
          filteredItems.push({
            title: value.params.title,
            description: result,
            to: { path: key },
          });
        }
      }

      return filteredItems;
    },
  },
};
</script>
